/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Orange_Poodle_TwirlInputs */

const en_full_orange_poodle_twirl = /** @type {(inputs: Full_Orange_Poodle_TwirlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared reports`)
};

const de_full_orange_poodle_twirl = /** @type {(inputs: Full_Orange_Poodle_TwirlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geteilte Berichte`)
};

/**
* | output |
* | --- |
* | "Shared reports" |
*
* @param {Full_Orange_Poodle_TwirlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const full_orange_poodle_twirl = /** @type {((inputs?: Full_Orange_Poodle_TwirlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Orange_Poodle_TwirlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_orange_poodle_twirl(inputs)
	return de_full_orange_poodle_twirl(inputs)
});